import { render, staticRenderFns } from "./AirQuality.vue?vue&type=template&id=30cd684d"
import script from "./AirQuality.vue?vue&type=script&lang=js"
export * from "./AirQuality.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports